import { DateFormatType } from './date-format-key'

const dateFormatValues = new Set<string>(Object.values(DateFormatType))

function isDateFormatType(value: string | null): value is DateFormatType {
  return value !== null && dateFormatValues.has(value)
}

export function normalizeDateFormat(value: string | null): DateFormatType | null {
  return isDateFormatType(value) ? value : null
}
